import { http } from '@/http/index'

export const unsubscribeFromService = async () => http.post('/consumer/unsubscribe-from-service')
